export default __webpack_public_path__ + "static/media/peach.e70ae3a0.gif";